// extracted by mini-css-extract-plugin
module.exports = {"popover":"PeriodDropdown_popover__1PtEv","calendar":"PeriodDropdown_calendar__MadKu","period-dropdown":"PeriodDropdown_period-dropdown__30mGN"};